import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsEventsService } from "../../services/google-analytics.service";

@Component({
  selector: 'app-dialog-consent',
  templateUrl: './dialog-consent.component.html',
  styleUrls: ['./dialog-consent.component.css']
})
export class DialogConsentComponent implements OnInit {
  @Input() dialogType: any;
  @Input() showButton: boolean = false;
  @Output() btnAction: EventEmitter<any> = new EventEmitter();

  icon = 'loading'
  platform: any;

  constructor(
    public googleAnalyticsService: GoogleAnalyticsEventsService,
  ) { }

  async ngOnInit() {
    if (this.dialogType === 'update_warning') {
      this.icon = 'dialog-confirmation';
    } else if (this.dialogType === 'missmatch') {
      this.icon = 'dialog-error';
    } else {
      console.log("PDP_PAGE_SUCCESS");
      this.icon = 'dialog-success';
    }
    setTimeout(() => {
      this.platform = localStorage.getItem('platform');
    }, 100);
  }

  close() {

  }

  manageConsent() {
    this.btnAction.emit();

  }

  redirectUrl() {
    // window.location.href = '';
    // window.open('', '_parent', '');
    // window.close();
    this.googleAnalyticsService.emitEvent("Got It Button", "platform", this.platform);
    if (this.platform.toLowerCase() === 'im3') {
      window.location.href = environment.im3HomePage
    } else {
      window.location.href = environment.bimaHomePage
    }
  }
}
